import {
  commissions as commissionsAPI,
} from '@/services';

export default {
  watch: {
    '$route.params': 'loadStartingData',
  },
  data: () => ({
    currentStep: 0,
    storageKey: 'commission',
  }),
  computed: {
    commissionManager() {
      return this.currentStep === 0;
    },
  },
  mounted() {
    this.canRender = true;
    this.loadStartingData();
  },
  methods: {
    // handlers
    goToDetailedPromoter(promoter_id) {
      this.$router.push(
        {
          name: 'promoters-commission-details',
          params: {
            id: promoter_id,
          },
        },
      );

      this.modal.showPromoterModal = false;
    },

    // handlers :: api
    exportReport() {
      this.getCommissionByProposal(this.currentID, true);
    },
    async loadStartingData() {
      // reset data
      this.list.payments = [];
      this.showReceived = false;
      this.showToBeReceived = false;
      this.details.show = false;

      // update period
      this.updatePeriod();

      // get data
      if (this.promoter_id) await this.getCommission();
      else await this.getCommissionPaymentMasterReport();
    },
    async loadDetails(date) {
      this.detailed_table_date = date;
      await this.getDetailedCommissionPaymentMasterReport(date);
      this.modal.showPromoterModal = true;
    },

    // api
    async getCommissionPaymentMasterReport() {
      this.loading = true;
      this.data_table = [];

      await commissionsAPI
        .getCommissionPaymentMasterReport({
          params: {
            ...this.pagination.financial.filters,
            ...await JSON.parse(sessionStorage.getItem(this.storageKey)),
          },
        })
        .then(({ data }) => {
          this.pagination.financial.data = data.data;
          this.data_table = data.data.data;
        })
        .catch(this.handlerError)
        .finally(() => {
          this.loading = false;
        });
    },
    async getDetailedCommissionPaymentMasterReport(date, shouldExport) {
      this.loading = true;

      await commissionsAPI
        .getDetailedCommissionPaymentMasterReport({
          params: {
            date: new Date(date).toISOString().split('T')[0],
            ...(shouldExport ? { output: 'csv' } : ''),
            ...(!shouldExport ? this.pagination['promoters-payment'].filters : ''),
          },
        })
        .then(({ data }) => {
          if (shouldExport) {
            this.handleExportRequest({ data, name: 'comissoes' });
          } else {
            this.pagination['promoters-payment'].data = data.data;
            this.detailed_table = data.data.data;
          }
        })
        .catch(this.handlerError)
        .finally(() => {
          this.loading = false;
        });
    },
    async getCommission() {
      this.loading = true;
      this.data_table = [];

      await commissionsAPI
        .getCommission({
          params: {
            ...this.pagination.financial.filters,
            ...await JSON.parse(sessionStorage.getItem(this.storageKey)),
            ...(this.promoter_id ? { promoter_id: this.promoter_id } : ''),
          },
        })
        .then(({ data }) => {
          this.pagination.financial.data = data.data;
          this.data_table = data.data.data;
        })
        .catch(this.handlerError)
        .finally(() => {
          this.loading = false;
        });
    },
    async getCommissionByProposal(id, shouldExport) {
      this.loading = true;
      this.currentID = id;

      if (!shouldExport) this.data_table = [];

      await commissionsAPI
        .getCommissionByProposal({
          id,
          params: {
            promoter_id: this.promoter_id,
            ...(shouldExport ? { output: 'csv' } : ''),
          },
        })
        .then(({ data }) => {
          if (shouldExport) {
            this.handleExportRequest({ data, name: 'comissoes' });
          } else {
            this.data_table = data.data;
            this.details.show = true;
          }
        })
        .catch(this.handlerError)
        .finally(() => {
          this.loading = false;
          this.details.show = true;
        });
    },
    async getCommissionPaymentReport() {
      this.loading = true;

      await commissionsAPI
        .getCommissionPaymentReport({
          params: {
            ...await JSON.parse(sessionStorage.getItem(this.storageKey)),
            ...(this.promoter_id ? { promoter_id: this.promoter_id } : ''),
          },
        })
        .then(({ data }) => {
          this.$set(this.list, 'payments', [
            {
              title: 'Recebido',
              value: data.data.paid_amount,
              updated_at: data.meta.datetime,
            },
            {
              title: 'Valor à Receber',
              value: data.data.pending_amount,
              updated_at: data.meta.datetime,
            },
          ]);
        })
        .catch(this.handlerError)
        .finally(() => {
          this.loading = false;
        });
    },
    async downloadReceipt({ id }) {
      this.loading = true;

      await commissionsAPI
        .getCommissionReceipt({ id })
        .then(({ data }) => {
          const link = document.createElement('a');

          link.href = `data:application/pdf;base64,${data.data.pdf_encoded_string}`;
          link.setAttribute('download', 'comprovante.pdf');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .catch(this.handlerError)
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
